import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Capability } from '__types__';
import useEvent from 'v1/helpers/hooks/useEvent';
import { PRODUCTIONS_ACTIONS } from 'store/v1/productions/productions.constants.js';
import { deleteBudgetExpense } from 'store/v1/productions/productions.actions.js';
import { displayAlert, openModal } from 'store/v1/ui/ui.actions.js';

import { MenuItem, RestrictedDropdown } from 'v1/components/shared';

// TODO: should use new flyover
const ProductionBudgetExpenseOptions = ({ slot }) => {
  const dispatch = useDispatch();

  useEvent(PRODUCTIONS_ACTIONS.DELETE_BUDGET_EXPENSE, {
    onSuccess: () =>
      dispatch(displayAlert('success', 'Expense slot removed successfully')),
    onFailure: () => dispatch(displayAlert('error', 'Something went wrong'))
  });

  const onSlotDelete = () => {
    const canDelete =
      !slot.expenses ||
      !slot.expenses.length ||
      !slot.expenses.some(assignment => !assignment.archived);

    canDelete
      ? dispatch(
          openModal('ConfirmModal', {
            title: 'Are you sure you want to delete this expense?',
            confirmLabel: 'Confirm delete',
            onConfirm: () =>
              dispatch(
                deleteBudgetExpense({
                  production_id: slot.production_id,
                  budget_expense_id: slot.id
                })
              )
          })
        )
      : dispatch(
          openModal('AlertModal', {
            title: 'Cannot delete slot if an expense is assigned',
            description:
              'An expense slot cannot be removed if it has an expense assigned to it. You’ll need to remove the expense from the slot before you can delete it.'
          })
        );
  };

  return (
    <RestrictedDropdown
      capabilitiesAtLeastOne={[
        Capability.PRODUCTION_READ,
        Capability.PRODUCTION_UPDATE
      ]}
      buttonIcon={<img src="/images/icon_ellipsis.svg" alt="" />}
      buttonClass="btn btn-link btn-small btn-square"
    >
      <MenuItem
        capabilities={Capability.PRODUCTION_UPDATE}
        onSelect={onSlotDelete}
      >
        <span className="MenuItem-icon">
          <img src="/images/icon_delete.svg" alt="" />
        </span>
        <span className="MenuItem-label">Remove expense</span>
      </MenuItem>
    </RestrictedDropdown>
  );
};

ProductionBudgetExpenseOptions.propTypes = {
  slot: PropTypes.object
};

export default ProductionBudgetExpenseOptions;
